"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var checkIsMatchActive_1 = __importDefault(require("./checkIsMatchActive"));
var checkIsMarketActive_1 = __importDefault(require("./checkIsMarketActive"));
var checkIsOddActive_1 = __importDefault(require("./checkIsOddActive"));
function checkIsBetslipOddActive(matchStatus, isMatchDisabled, marketStatus, oddStatus, oddIsActive, betStop // TODO: Make betStop require.
) {
    var isActiveMatch = checkIsMatchActive_1.default(matchStatus, isMatchDisabled, betStop);
    var isActiveMarket = checkIsMarketActive_1.default(marketStatus);
    var isActiveOdd = checkIsOddActive_1.default(oddStatus, oddIsActive);
    return isActiveMatch && isActiveMarket && isActiveOdd;
}
exports.default = checkIsBetslipOddActive;
//# sourceMappingURL=checkIsBetslipOddActive.js.map